import React, { Component } from 'react';
import { observer } from 'mobx-react';

import Login from './LoginUI';
import PasswordReset from './PasswordReset';
import Registration from './Registration';
import TrendAnalysisUI from './trendAnalysis/TrendAnalysisUI';

import About from './About';
import TestListUI from './products/TestListUI';
import ProfileListUI from './products/ProfileListUI';
import ProductPriceList from './products/ProductPriceList';
import PatientTestUI from './pos/PatientTestUI';
import PayableUI from './doctors/PayableUI';
import DoctorSummary from './doctors/DoctorSummary';
import LabSummary from './labs/LabSummary';
import PaymentSummaryUI from './doctors/PaymentSummaryUI';
import PaymentDetails from './doctors/PaymentDetails';
import ReceivableUI from './labs/ReceivableUI';
import InvoiceUI from './labs/InvoiceUI';
import PaymentUI from './doctors/PaymentUI';
import InvoiceDetails from './labs/InvoiceDetails';
import LockedReferrerUI from './Referrers/LockedReferrerUI';
import DenominationUi from './paymentDenomination/DenominationUi';
import ReferrerSampleStatus from './ReferrerSampleStatus/ReferrerSampleStatus';

class SelectedComponent extends Component {

    evaluateComponent() {
        const currentComponent = this.props.appStore.currentComponent;

        if (!currentComponent) {
            return <Login appStore={this.props.appStore} />;
        }
        
        switch (currentComponent.key) {
            case 'tests': {
                return <TestListUI appStore={this.props.appStore} />;
            }
            case 'profiles': {
                return <ProfileListUI appStore={this.props.appStore} />;
            }
            case 'priceList': {
                return <ProductPriceList appStore={this.props.appStore} params={currentComponent.params}/>;
            }
            case 'labs': {
                return <About appStore={this.props.appStore} />
            }
            case 'payables': {
                return <PayableUI appStore={this.props.appStore} />
            }
            case 'doctorSummary': {
                return <DoctorSummary appStore={this.props.appStore} params={currentComponent.params}/>
            }
            case 'payments': {
                return <PaymentUI appStore={this.props.appStore} />
            }
            case 'denomination': {
                return <DenominationUi appStore={this.props.appStore} />;
            }
            case 'doctorPaymentDetails': {
                return <PaymentDetails appStore={this.props.appStore} params={currentComponent.params} />
            }
            case 'receivables': {
                return <ReceivableUI appStore={this.props.appStore} />
            }
            case 'labSummary': {
                return <LabSummary appStore={this.props.appStore} params={currentComponent.params}/>
            }
            case 'invoices': {
                return <InvoiceUI appStore={this.props.appStore}/>
            }
            case 'labInvoiceDetails': {
                return <InvoiceDetails appStore={this.props.appStore} params={currentComponent.params}/>
            }
            case 'referrers': {
                return <LockedReferrerUI appStore={this.props.appStore} params={currentComponent.params}/>
            }
    
            case 'login': {
                return <Login appStore={this.props.appStore} />;
            }
            case 'passwordReset': {
                return <PasswordReset appStore={this.props.appStore} />;
            }
            case 'registration': {
                return <Registration appStore={this.props.appStore} />;
            }
            case 'trendAnalysis': {
                return <TrendAnalysisUI appStore={this.props.appStore} />;
            }
            case 'about': {
                return <About appStore={this.props.appStore} />;
            }
            case 'referrer-sample-status': {
                return <ReferrerSampleStatus appStore={this.props.appStore} />;
            }

            default: {
                return <About appStore={this.props.appStore} />;
            }
        }
    }

    render() {
        return (this.evaluateComponent());
    }
}

export default observer(SelectedComponent);
